import { SUPPORTED_FILE_FORMATS, MAX_FILE_SIZE_BYTES } from '@/types/application.types';

/**
 * Resume picker checks shared by Home (search by resume) and My Jobs (Recommended → upload resume).
 * Mirrors Flutter IWebHomeRepository.pickFilesFromSystem + the 5MB check in the blocs,
 * and GenericHelpers.isAgreedWithDataPolicyToUploadResume.
 */

// Flutter ErrorConstants texts
export const FILE_FORMAT_NOT_SUPPORTED = 'File format of the uploaded file is not supported.';
export const FILE_NAME_INVALID = 'File name should be only alphanumeric characters';
export const FILE_SIZE_EXCEEDED = 'Max File size is 5MB';

/** Flutter pickFilesFromSystem file-name check */
const VALID_FILE_NAME = /^[^/:*?"<>$|\x00-\x1F\x7F]+$/;
/** Flutter GenericHelpers.isAgreedWithDataPolicyToUploadResume pref */
const DATA_POLICY_AGREED_KEY = 'isAgreedWithDataPolicyToUploadResume';

export function isAgreedWithDataPolicy(): boolean {
  return localStorage.getItem(DATA_POLICY_AGREED_KEY) === 'true';
}

export function setAgreedWithDataPolicy(): void {
  localStorage.setItem(DATA_POLICY_AGREED_KEY, 'true');
}

/** Returns the Flutter error text for an unusable resume file, or null when it can be uploaded. */
export function validateResumeFile(file: File): string | null {
  if (!VALID_FILE_NAME.test(file.name)) return FILE_NAME_INVALID;
  // Flutter compares PlatformFile.extension (name.split('.').last) as-is, so it rejects "CV.PDF".
  // That is treated as a Flutter bug (doc/FLUTTER_DEVIATIONS.md): the extension is lower-cased.
  const ext = (file.name.split('.').pop() ?? '').toLowerCase();
  if (!SUPPORTED_FILE_FORMATS.includes(ext)) return FILE_FORMAT_NOT_SUPPORTED;
  if (file.size > MAX_FILE_SIZE_BYTES) return FILE_SIZE_EXCEEDED;
  return null;
}
